export type PersonalizationStateV2 = {
  metadata: {
    textStyle: { id: string; name: string; url: string }
    textPosition: string
    textPositionId: string
    textColors: { id: string; colors: string; rotation: number }
    personalizeText: {
      raw: string
    }
  }
}

const initialState = {
  textStyle: { id: '', name: '', url: '' },
  textPosition: '',
  textPositionId: '',
  textColors: { id: '', colors: '', rotation: 0 },
  personalizeText: {
    raw: ''
  }
}

export const usePersonalizationStoreV2 = defineStore('personalizationStoreV2', {
  state: (): PersonalizationStateV2 => ({
    metadata: { ...initialState }
  }),
  actions: {
    updateMetadata(nextMetadata: Partial<PersonalizationStateV2['metadata']>) {
      this.metadata = { ...this.metadata, ...nextMetadata }
    },
    reset() {
      this.metadata = { ...initialState }
    }
  }
})
